// The menu selector on the screen (CategoryList) and the voice assistant know each other only through this module:
// the assistant can open a category on the screen, and it hears when the waiter taps a product there.

const lists = new Set();
let tapObserver = null;

export const registerCategoryList = list => {
  lists.add(list);
  return () => lists.delete(list);
};

// ids: the category ids from the top category down to the category to show; true when a visible selector shows it
export const showCategoryOnScreen = (ids, type) => {
  let shown = false;
  lists.forEach(list => {
    if (list.showCategoryPath(ids, type)) shown = true;
  });
  return shown;
};

export const hideCategoryOnScreen = id => lists.forEach(list => list.hideCategory(id));

export const setMenuTapObserver = observer => {
  tapObserver = observer;
};

// a tap on a product of the selector: { id, entityType, quantity }
export const notifyMenuTap = tap => {
  try {
    if (tapObserver) tapObserver(tap);
  } catch (e) {
    console.error("menu tap observer failed", e);
  }
};
